import React from 'react';

import AdoptedRegion from '../primitives/AdoptedRegion';

interface IContentBodyProps {
    content: DocumentFragment | null;
}

const ContentBody: React.FC<IContentBodyProps> = ({ content }) => (
    <AdoptedRegion className="content-page__body" id="article_body" content={content} />
);

export default ContentBody;
